/*
 * Ryan O'Dowd
 * 2019-05-14
 * © Copyright 2012 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({colors}) => {
  return {
    outerContainer: (isWebApp) => {
      const styles: any = {
        display: 'flex',
        flexGrow: 1,
        flexDirection: 'column',
        width: '100%',
        // @TODO: overflow: 'scroll',
        justifyContent: 'center',
        alignItems: 'center',
        color: colors.white,
      };

      if (isWebApp) {
        styles.maxHeight = '100vh';
        styles.minHeight = '100vh';
        styles.overflow = 'hidden';
      }

      return styles;
    },

    scrollWrapper: {
      display: 'flex',
      flexGrow: 1,
    },
    spacerBeforeFooter: {
      display: 'flex',
      flexGrow: 1,
    },
  };
};

export default getStyles;
